import { useContext, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { atom, useRecoilState } from "recoil";
import { keylessAreaState, mobilityStoreIdState } from "../../../search-dms/state";
import { AddRounded, DeleteRounded, EditRounded } from "@mui/icons-material";
import CustomMap from "./KeylessAreaMap";
import _ from "underscore";
import KeylessOperationAreaEditFormPopup from "./KeylessOperationAreaEditFormPopup";
import { deleteKeylessOperationArea } from "../../../search-dms/dmsSearch.actions";
import { SET_SNACKBAR } from "../../../common/utils";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";

export interface KeylessArea {
  id: number;
  keyLessInfo: string;
  lat: number;
  lon: number;
  radius: number;
  mobilityStoreId: number;
}

var voidKeylessArea: KeylessArea;

interface MapInfo {
  lat: number;
  lng: number;
  radius: number;
}

/// Also works with keylessInfo, and other useRecoilState stuff
function getAllInfo(keylessAreas: any) {
  return <>
    <div>
      keylessAreas:
      {Object.entries(keylessAreas).map(([key, value]) => (
        <div key={key}>
          <strong>{key}:</strong> {value !== null ? value as string | number : 'null'}
        </div>
      ))}
    </div>
  </>
}

type KeylessOperationAreaProps = {
  isNew: boolean;
  shouldSave: boolean;
  setPayload: (value: any) => void;
  isKeyLess: boolean;
  setPayloadInvalid: (value: boolean) => void;
}

export const showEditKeylessOperationAreaState = atom<boolean>({
  key: "ShowEditKeylessOperationArea",
  default: false,
});

const KeylessOperationArea = (props: KeylessOperationAreaProps) => {
  const { t } = useTranslation(["network", "translation"]);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [keylessAreas, setKeylessAreas] = useRecoilState(keylessAreaState);
  const [mobilityStoreId, setMobilityStoreId] = useRecoilState(mobilityStoreIdState);

  const [showEdit, setShowEdit] = useRecoilState(showEditKeylessOperationAreaState);
  const [showDelete, setShowDelete] = useState(false);
  const [formItem, setFormItem] = useState<KeylessArea | null>(null);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  function getKeylessInfoLabel(keylessArea: KeylessArea, t: any) {
    return <>
      <TextField
        name="keyLessInfo"
        label={t("dmsDetail.keyless.operationAreaTab.keyLessInfo")}
        multiline
        rows={3}
        fullWidth
        InputProps={{
          style: {
            border: "2px dashed #ccc",
            borderRadius: "5px",
          },
        }}
        value={keylessArea.keyLessInfo}
        disabled={true}
      />
    </>
  }

  function getKeylessInfoMapInfo(keylessArea: KeylessArea, t: any) {
    return <>
      <Stack
        direction="row"
        spacing={2}
      >
        <TextField
          name="lat"
          label={t("dmsDetail.keyless.operationAreaTab.latitude")}
          value={keylessArea.lat}
          disabled={true}
        />
        <TextField
          name="lon"
          label={t("dmsDetail.keyless.operationAreaTab.longitude")}
          value={keylessArea.lon}
          disabled={true}
        />
        <TextField
          name="radius"
          label={t("dmsDetail.keyless.operationAreaTab.radius")}
          value={keylessArea.radius}
          disabled={true}
        />
      </Stack>
    </>
  }

  function getKeylessInfoMap(keylessArea: any) {
    return <>
      <CustomMap latitude={keylessArea.lat || 0} longitude={keylessArea.lon || 0} radius={keylessArea.radius} onClick={() => { }} />
    </>
  }

  function getKeylessInfoAddButton(mobilityStoreId: number) {
    const createEmptyKeylessArea = (): KeylessArea => ({
      id: -1,
      keyLessInfo: "",
      lat: 45,
      lon: 7,
      radius: 1000,
      mobilityStoreId: mobilityStoreId,
    });

    return <>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', flexDirection: 'row' }}>
        <IconButton
          color={"accent"}
          onClick={() => {
            setFormItem(createEmptyKeylessArea());
            setShowEdit(true);
          }}
        >
          <AddRounded />
        </IconButton>
      </div >
    </>
  }

  function getKeylessInfoEditButton(keylessArea: KeylessArea, t: any, index: number) {
    return <>
      {//hasScope(NetworkScope.MsMng) && isDisabled && generalInfo?.currentStatus !== CUR_STATUS_DMS.TERMINATED && (
        <IconButton
          color={"accent"}
          onClick={() => {
            setFormItem({ ...keylessAreas[index] });
            setShowEdit(true);
          }}
        >
          <EditRounded />
        </IconButton>
        //)
      }
    </>
  }

  function getKeylessInfoDeleteButton(keylessArea: KeylessArea, t: any, index: number) {
    return <>
      {//hasScope(NetworkScope.MsMng) && isDisabled && generalInfo?.currentStatus !== CUR_STATUS_DMS.TERMINATED && (
        <IconButton
          color={"accent"}
          disabled={keylessAreas.length <= 1}
          onClick={() => {
            setDeleteId(keylessArea.id);
            setShowDelete(true);
          }}
        >
          <DeleteRounded />
        </IconButton>
        //)
      }
    </>
  }

  function getKeylessInfoButtons(keylessArea: KeylessArea, t: any, index: number) {
    return <>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', flexDirection: 'row' }}>
        {getKeylessInfoEditButton(keylessArea, t, index)}
        {getKeylessInfoDeleteButton(keylessArea, t, index)}
      </div>
    </>
  }


  function getPadding() {
    return <>
      <div style={{ padding: '30px' }} />
    </>
  }

  function getKeylessInfoComponent(keylessArea: any, t: any, index: number) {
    return <>
      {getKeylessInfoButtons(keylessArea, t, index)}
      {getKeylessInfoLabel(keylessArea, t)}
      {getKeylessInfoMapInfo(keylessArea, t)}
      {getKeylessInfoMap(keylessArea)}
      {getPadding()}
    </>
  }

  function showEditPopup() {
    return <>
      {showEdit && formItem && (
        <Dialog open={showEdit} onClose={() => setShowEdit(false)} maxWidth="md" fullWidth>
          <KeylessOperationAreaEditFormPopup
            keylessArea={formItem}
            onChange={handleChange}
          />
        </Dialog>
      )}
    </>
  }

  function showDeletePopup() {
    function handleDelete() {
      deleteKeylessOperationArea(deleteId)
        .then((res: any) => {
          setKeylessAreas((prev: any) =>
            prev.filter((area: any) => area.id !== deleteId)
          );
          dispatchGlobalData(SET_SNACKBAR.SUCCESS);
        })
        .catch((err: any) => {
          dispatchGlobalData(SET_SNACKBAR.ERROR);
        });
      setShowDelete(false);
    }

    return <>
      {showDelete && (
        <Dialog open={showDelete} onClose={() => setShowDelete(false)} maxWidth="md" fullWidth>
          <DialogTitle id="alert-dialog-title">
            {t("dmsDetail.keyless.operationAreaTab.dialogDelete.title")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("dmsDetail.keyless.operationAreaTab.dialogDelete.content")}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setShowDelete(false)}>{t("dmsDetail.keyless.operationAreaTab.dialogDelete.action.cancel")}</Button>
            <Button variant="contained" onClick={() => handleDelete()}>{t("dmsDetail.keyless.operationAreaTab.dialogDelete.action.confirm")}</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  }

  const handleChange = (index: number, field: string, value: any) => {
    // index param is unused now, but keep for signature compatibility
    if (!formItem) return;

    setFormItem({ ...formItem, [field]: value });
  };

  return <>
    {getKeylessInfoAddButton(mobilityStoreId)}

    {keylessAreas.map((area: any, index: number) => getKeylessInfoComponent(area, t, index))}

    {showDeletePopup()}

    {showEditPopup()}
  </>
}

export default KeylessOperationArea;
